/* ENCHAINE wishlist - theme-native, no app, no third party.
   Saves product handles in localStorage on the visitor's device. */
(function () {
  var KEY = 'enchaine_wishlist';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync(); render();
  }
  function toggle(handle) {
    var list = read(), i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.unshift(handle);
    write(list);
  }

  function money(cents) {
    var cfg = window.ENCHAINE_WISHLIST || {};
    try {
      return new Intl.NumberFormat(cfg.locale || 'en', {
        style: 'currency', currency: cfg.currency || 'USD'
      }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function sync() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-wishlist-toggle')) > -1;
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  function card(p) {
    var img = p.featured_image ? p.featured_image : (p.images && p.images[0]);
    var src = img ? (img.indexOf('//') === 0 ? 'https:' + img : img) : '';
    return '<div class="wl-card">' +
      '<a class="wl-card__media" href="/products/' + p.handle + '">' +
        (src ? '<img src="' + src.split('?')[0] + '?width=533" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="533" height="666">' : '') +
      '</a>' +
      '<div class="wl-card__body">' +
        '<a class="wl-card__title" href="/products/' + p.handle + '">' + p.title + '</a>' +
        '<span class="wl-card__price">' + money(p.price) + '</span>' +
        '<button type="button" class="wl-card__remove" data-wishlist-toggle="' + p.handle + '">Remove</button>' +
      '</div>' +
    '</div>';
  }

  function render() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var list = read();
    if (!list.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;

    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var live = items.filter(Boolean);
      // drop handles that no longer resolve (deleted/unpublished products)
      var alive = live.map(function (p) { return p.handle; });
      if (alive.length !== list.length) {
        try { localStorage.setItem(KEY, JSON.stringify(alive)); } catch (e) {}
      }
      grid.innerHTML = live.map(card).join('');
      if (!live.length && empty) empty.hidden = false;
      sync();
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    toggle(btn.getAttribute('data-wishlist-toggle'));
  });

  window.addEventListener('storage', function (e) { if (e.key === KEY) { sync(); render(); } });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(); render(); });
  } else { sync(); render(); }
})();
